module.exports = __webpack_public_path__ + "img/18m1.e11276e2.jpg";